export function findFilesInFileList(fileList, files) {
  let found = false

  for (let i = 0; i < files.length; i += 1) {
    const file = files[i]

    found = !!fileList.find(existingFile => existingFile.nome === file.name)

    if (found) return true
  }
  return false
}

function readFileAsDataUrl(file) {
  return new Promise(resolve => {
    const reader = new FileReader()
    reader.onload = () => {
      resolve({
        nome: file.name,
        dataUrl: reader.result,
      })
    }
    reader.readAsDataURL(file)
  })
}

export async function appendFilesToList(fileList, files) {
  const readers = []

  files.forEach(file => { readers.push(readFileAsDataUrl(file)) })

  await Promise
    .all(readers)
    .then(values => {
      values.forEach(it => {
        fileList.push({
          nome: it.nome,
          dataUrl: it.dataUrl,
        })
      })
    })

  return fileList
}

export function removeFileFromList(fileList, file) {
  const index = fileList.indexOf(file)

  return fileList.splice(index, 1)
}
